import { render, staticRenderFns } from "./DamayanRF.vue?vue&type=template&id=70a2cb81&"
import script from "./DamayanRF.vue?vue&type=script&lang=js&"
export * from "./DamayanRF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports